import {
  getJavaScriptTipsAndNotesMarkdown,
  javascriptAccessPreviousDataMarkdown,
  javascriptLoggingAndDebuggingMarkdown,
  javascriptNotableSdkMarkdown,
} from '../../ConfigFields/JavaScriptBlock/documentation';

export const switchBlockDocumentationMarkdown = `
When to Use
-----------

* Use the Conditional block when you want to route the flow based on a true/false result.
* This block evaluates a JavaScript expression and routes the flow based on whether it returns true or false.

How to Use
----------

### Basic Structure

Write your code as if it's the body of a function with a return statement to return true or false.

~~~javascript
// Process data here
const aNewVariable = 'someValue';
const processedData = aNewVariable.toUpperCase();
return processedData === aNewVariable;
~~~

${javascriptAccessPreviousDataMarkdown}
${javascriptLoggingAndDebuggingMarkdown}
${javascriptNotableSdkMarkdown}

Examples
--------

### 1. Basic Calculation
~~~javascript
/**
 * Calculate BMI from height and weight and return true if Underweight
 */
const height = patientMetrics.data.heightInMeters;
const weight = patientMetrics.data.weightInKg;
const bmi = weight / (height * height);
return bmi < 18.5;
~~~

${getJavaScriptTipsAndNotesMarkdown({ errorHandlingVariant: 'ThrowError' })}
`;
